// extracted by mini-css-extract-plugin
module.exports = {"root":"Notifications_root__WF6sb","rootButtonRefresh":"Notifications_rootButtonRefresh__H0517"};